var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }